import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import clsx from 'clsx'
import { Button } from './Button'

interface ErrorStateProps {
  title?: string
  description?: string
  onRetry?: () => void
  className?: string
}

/**
 * Brand-styled error state for failed data fetches.
 *
 * Use instead of rendering zeroed metrics or empty tables when a query
 * fails — especially on financial pages where "0" reads as a real value.
 */
export function ErrorState({
  title = 'Unable to load data',
  description = 'Something went wrong while fetching this information. Your data is safe — try again.',
  onRetry,
  className,
}: ErrorStateProps) {
  return (
    <div className={clsx('flex flex-col items-center justify-center text-center py-12 px-4', className)}>
      <div className="h-14 w-14 rounded-card bg-surface-alt flex items-center justify-center mb-5">
        <ExclamationTriangleIcon className="h-6 w-6 text-danger" />
      </div>
      <h3 className="font-outfit text-h4 text-ink">{title}</h3>
      <p className="font-inter text-body-sm text-ink-muted mt-2 max-w-md">{description}</p>
      {onRetry && (
        <Button variant="secondary" size="sm" className="mt-5" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  )
}
